
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Watch, Component, Prop, Vue } from "vue-property-decorator";
import axios from "@/libraries/axios/main";
import Selected from '@/models/valorization/filter/Selected';

am4core.useTheme(am4themes_animated);

@Component
export default class BaseInternalValorization extends Vue {
  protected loading = false;
  protected url = "/valorization/observatory/flora/threat-modes";
  protected params = {};
  protected properties = [];
  protected error = "";
  protected message = "";
  protected model: {name: string, label:string, type: string}[] = [];
  get headers() {
    return this.model.map(item => ({text: item.label, value: item.name}));
  }
  protected data = [];
  //@ts-ignore
  @Prop({type: Selected, default: null}) selected: Selected|null;

  @Prop({ type: Object, default: null })
  // @ts-ignore
  value;

  @Prop({ type: String, default: null })
  // @ts-ignore
  stationProp: String;

  @Prop({ type: String, default: null })
  // @ts-ignore
  groupProp: String;

  @Prop({ type: String, default: null })
  // @ts-ignore
  startDateProp;

  @Prop({ type: String, default: null })
  // @ts-ignore
  endDateProp;

  @Watch("stationProp")
  onStationPropChanged() {
    this.loadData();
  }

  @Watch("groupProp")
  onGroupPropChanged() {
    this.loadData();
  }

  @Watch("startDateProp")
  onStartDatePropChanged() {
    this.loadData();
  }

  @Watch("endDateProp")
  onEndDatePropChanged() {
    this.loadData();
  }

  loadData() {
    let vm = this;

    this.loading = true;

    axios
      .post(this.url, this.params)
      .then(response => {
        let data = response.data;
        this.properties = data.properties;
        this.error = data.error;
        this.message = data.message;
        this.model = data.model;
        this.data = data.data;
        this.$emit("input", data);
        this.drawData();
        this.loading = false;
      })
      .catch(error => {
        let title = "Erreur";
        let description = "";
        // Error
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);

          // description = error.message;
        }
        console.log(error.config);
        this.loading = false;
      })
      .then(() => {
        this.loading = false;
      });
  }

  drawData() {}



  mounted() {
    this.params = {
      station: this.stationProp,
      group: this.groupProp,
      startDate: this.startDateProp,
      endDate: this.endDateProp
    };

    this.loadData();
  }
}
